import { Box, Chip } from '@mui/material';

interface IFilterChip<T extends string> {
  value: T;
  label: string;
}

interface IFilterBarProps<T extends string> {
  chips: IFilterChip<T>[];
  value: T;
  onChange: (value: T) => void;
}

// Linha de chips-pill (Todos/Créditos/Débitos/...) — guia seções 34/45.
export function FilterBar<T extends string>({ chips, value, onChange }: IFilterBarProps<T>) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {chips.map((chip) => (
        <Chip
          key={chip.value}
          label={chip.label}
          size="small"
          color={value === chip.value ? 'primary' : 'default'}
          variant={value === chip.value ? 'filled' : 'outlined'}
          onClick={() => onChange(chip.value)}
        />
      ))}
    </Box>
  );
}
